import { APIRoute } from '@/modules/utils'
import { UserCard } from '@/dataV3/Search/UserCard'

export const Route: APIRoute = {
  method: 'GET',
  path: '/member/:profileId/user_card',
}

export type UrlParams = {
  profileId: string
}

export type Response = UserCard
